import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../../hooks/useNotifications'
import { redactMessage } from '../../../../services/chatService'

export default function RedactSingleMessageOverlay({ selectedMessage, updateRedactedMessagesList, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()
  const readyToDeleteMessage = selectedMessage?.replace('-messageInQuestion', '')

  const submitOnClick = async () => {
    overlay.close()
    try {
      const messageRedactPayload = {
        messageRedactList: [
          {
            messageId: readyToDeleteMessage,
          },
        ],
      }
      await redactMessage(messageRedactPayload)
      ok(t('user.messages.redactMessageSuccess', 'Message redacted'))
      updateRedactedMessagesList([readyToDeleteMessage])
    } catch (err) {
      error(
        `${t('user.messages.redactMessageFailure', {
          defaultValue: `Failed to redact message`,
        })}${err.message && `: ${err.message}`}`,
        err
      )
    }
  }

  return (
    <DialogOverlay title={t('action.redact', 'Redact')} {...overlay}>
      <Paragraph size="sm">
        {t('user.messages.redactMessageConfirmation', 'Are you sure you want to redact this message?')}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={submitOnClick} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
